import { useState } from 'react';
import { WhatsAppMediaType } from '../../../../utils/whatsapp/media.util';
import { UploadStep } from 'src/modules/communications/types/whatsapp/media.type';

interface UseFileUploadStateReturn {
  selectedFile: File | null;
  selectedMediaType: WhatsAppMediaType | null;
  uploadedFileId: string | null;
  uploadStep: UploadStep;
  uploadError: string | null;
  setSelectedFile: (file: File | null) => void;
  setSelectedMediaType: (type: WhatsAppMediaType | null) => void;
  setUploadedFileId: (id: string | null) => void;
  setUploadStep: (step: UploadStep) => void;
  setUploadError: (error: string | null) => void;
  resetFileState: () => void;
}

/**
 * Hook that manages file upload state.
 * It will store the selected file, media type, uploaded file ID, upload step, and upload error.
 * It will also provide functions to set the selected file, media type, uploaded file ID, upload step, and upload error.
 * It will also provide a function to reset the file state.
 */
export const useFileUploadState = (): UseFileUploadStateReturn => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [selectedMediaType, setSelectedMediaType] =
    useState<WhatsAppMediaType | null>(null);
  const [uploadedFileId, setUploadedFileId] = useState<string | null>(null);
  const [uploadStep, setUploadStep] = useState<UploadStep>('none');
  const [uploadError, setUploadError] = useState<string | null>(null);

  const resetFileState = () => {
    setSelectedFile(null);
    setSelectedMediaType(null);
    setUploadedFileId(null);
    setUploadStep('none');
    setUploadError(null);
  };

  return {
    selectedFile,
    selectedMediaType,
    uploadedFileId,
    uploadStep,
    uploadError,
    setSelectedFile,
    setSelectedMediaType,
    setUploadedFileId,
    setUploadStep,
    setUploadError,
    resetFileState,
  };
};
